import React from "react";
import { Link, useLocation } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

const Sidebar = ({ studentData }) => {
  const location = useLocation();

  const navLinks = [
    { to: "/", icon: "bi-bar-chart-line", label: "Dashboard" },
    { to: "/dailymodule", icon: "bi-journal-bookmark", label: "Course" },
  
    { to: "/profile", icon: "bi-person-plus", label: "Profile " },
     // { to: "/progress", icon: "bi-file-earmark", label: "Progress Tracker" }, 
  ];
  return (
    <>
      {/* Sidebar for large screens */}
    
     <aside
        className="d-none d-lg-flex flex-column bg-white border-end"
        style={{
          height: "100vh",
          minHeight: 0,
          width: "200px",
          minWidth: "220px",
          overflowY: "auto",
        }}
      >
       <div className="px-4 pt-4 pb-2 border-bottom">
          {/* Logo Image */}
          <img
            src="/logo.png"
            alt="Internskool Logo"
            width={32}
            height={32}
            style={{ borderRadius: "8px" }}
          />
          <span className="fw-bold fs-4" style={{ marginLeft:"8px" }}>Internskool</span>
        </div>
       

        <nav className="flex-grow-1 px-2 py-3">
          <ul className="nav flex-column gap-1">
            {navLinks.map((link) => (
              <li className="nav-item" key={link.to}>
                <Link
                  className={`nav-link d-flex align-items-center gap-2${
                    location.pathname === link.to
                      ? " active text-primary fw-bold"
                      : " text-dark"
                  }`}
                  to={link.to}
                  style={
                    location.pathname === link.to
                      ? { background: "#e7f1ff", borderRadius: "6px" }
                      : {}
                  }
                >
                  <i className={`bi ${link.icon}`}></i>
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
      {/* Offcanvas sidebar for small screens (same icons) */}
      <div className="d-lg-none">
        <button
          className="btn btn-outline-secondary m-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#sidebarOffcanvas"
          aria-controls="sidebarOffcanvas"
        >
          <i className="bi bi-list"></i>
        </button>
        <div
          className="offcanvas offcanvas-start"
          tabIndex="-1"
          id="sidebarOffcanvas"
          aria-labelledby="sidebarOffcanvasLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="sidebarOffcanvasLabel">
              Internskool
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div
            className="offcanvas-body p-0"
            style={{ height: "100vh", minHeight: 0, overflowY: "auto" }}
          >
            {/* Sidebar content reused here */}
            <aside
              className="flex-column bg-white border-end"
              style={{ width: "100%" }}
            >
              <div className="px-4 pt-4 pb-2 border-bottom">
                <div className="d-flex align-items-center gap-2">
                  {/* Book Icon */}
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="28" height="28" rx="6" fill="#212529" />
                    <rect
                      x="7"
                      y="15"
                      width="3"
                      height="6"
                      rx="1"
                      fill="white"
                    />
                    <rect
                      x="12"
                      y="11"
                      width="3"
                      height="10"
                      rx="1"
                      fill="white"
                    />
                    <rect
                      x="17"
                      y="8"
                      width="3"
                      height="13"
                      rx="1"
                      fill="white"
                    />
                  </svg>

                  <span className="fw-bold fs-4">Student Dashboard</span>
                </div>
              </div>
              <nav className="px-2 py-3">
                <ul className="nav flex-column gap-1">
                  <li className="nav-item">
                    <Link
                      className="nav-link active d-flex align-items-center gap-2"
                      to="/"
                      style={{ background: "#f5f5f5", borderRadius: "6px" }}
                    >
                      <i className="bi bi-bar-chart-line"></i>
                      Dashboard
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      className="nav-link d-flex align-items-center gap-2 text-dark no-transform"
                      to="/dailymodule"
                    >
                      <i className="bi bi-journal-bookmark"></i>
                      Course
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link d-flex align-items-center gap-2 text-dark"
                      to="/profile"
                    >
                      <i className="bi bi-file-earmark"></i>
                      Profile
                    </Link>
                  </li>
                </ul>
              </nav>
              <div className="mt-auto px-4 pb-3 pt-2 border-top">
                <span
                  className="rounded-circle bg-light d-inline-block"
                  style={{ width: "24px", height: "24px", marginLeft: "-10px" }}
                ></span>
                <div className="d-flex align-items-center gap-2" style={{ marginLeft: "-10px" }}>
                  <i
                    className="bi bi-person-circle"
                    style={{ fontSize: "1.2rem" }}
                  ></i>
                  <div className="flex-grow-1">
                    <div
                      className="fw-semibold"
                      style={{ fontSize: "0.95rem" }}
                    >
                      {studentData?.name || "Student"}
                    </div>
                    <div
                      className="text-muted small"
                      style={{ fontSize: "0.8rem" }}
                    >
                      {studentData?.email || "student@example.com"}
                    </div>
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
